import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useFeatures } from '@atc/features';
import { Popup, Button, Glyphicon, IconButton } from 'reaxl';
import _get from 'lodash/get';

/**
 * Renders the button for chat
 * @param {string} className        - classname to add to button
 * @param {function} onChatClick    - callback for clicking the chat button
 * @param {object} props            - properties to pass to button
 */
const renderButton = (className, onChatClick, props, uiContext, isDealerNameRelocation) => {
  if (uiContext === 'iconButton') {
    return /*#__PURE__*/_jsx(IconButton, {
      onClick: onChatClick,
      label: isDealerNameRelocation ? 'Chat' : 'Chat with Us',
      glyph: "commenting-o"
    });
  }
  if (uiContext === 'iconButtonStacked') {
    return /*#__PURE__*/_jsx(IconButton, {
      glyph: "commenting-o",
      label: "Chat",
      layout: "stacked",
      onClick: onChatClick,
      size: "large"
    });
  }
  const bsStyle = {
    button: 'secondary',
    link: 'link'
  }[uiContext];

  // delete invalid dom attributes before spreading
  delete props.merchantId;
  return /*#__PURE__*/React.createElement(Button, Object.assign({}, props, {
    className: className,
    block: uiContext === 'button',
    bsStyle: bsStyle,
    onClick: onChatClick
  }), _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "commenting-o",
    className: "margin-right-2",
    "aria-hidden": "true"
  })), "Chat with Dealer");
};

/**
 *  This component is now solely used for Gubagoo
 *  Renders the popup and button for chat
 */
function OwnerChatGubagoo(_ref) {
  let {
    className,
    listing,
    onChatClick = () => {},
    gubagooUrl = '',
    uiContext,
    ...rest
  } = _ref;
  const [state, setState] = useState({
    hasError: false,
    isUrlValid: true
  });
  const {
    dealer_name_relocation: [isDealerNameRelocationFlagEnabled]
  } = useFeatures(['dealer_name_relocation']);
  const isPrivateSeller = _get(listing, 'owner.privateSeller', false);
  const isDealerNameRelocation = isDealerNameRelocationFlagEnabled && !isPrivateSeller;

  // Validate the URL before rendering the Popup
  const validateUrl = useCallback(async () => {
    try {
      const response = await fetch(gubagooUrl, {
        method: 'HEAD'
      });
      if (!response.ok) {
        if (window && window.newrelic) {
          window.newrelic.addPageAction('ThirdPartyError', {
            thirdPartyName: 'GUBAGOO',
            component: 'OwnerChatGubagoo',
            message: 'Invalid URL',
            url: window.location.href,
            gubagooUrl
          });
        }
        setState({
          hasError: false,
          isUrlValid: false
        });
      } else {
        setState({
          hasError: false,
          isUrlValid: true
        });
      }
    } catch (error) {
      setState({
        hasError: false,
        isUrlValid: false
      });
      if (window && window.newrelic) {
        window.newrelic.addPageAction('ThirdPartyError', {
          thirdPartyName: 'GUBAGOO',
          component: 'OwnerChatGubagoo',
          message: 'An error occurred while validating the URL',
          url: window.location.href,
          gubagooUrl,
          error
        });
      }
    }
  }, [gubagooUrl]);
  useEffect(() => {
    if (gubagooUrl) {
      validateUrl();
    } else {
      setState({
        hasError: false,
        isUrlValid: false
      });
    }
  }, [gubagooUrl, validateUrl]);
  if (state.hasError || !state.isUrlValid) {
    return null;
  }
  return /*#__PURE__*/_jsx(Popup, {
    "data-cmp": "ownerChat",
    width: 360,
    height: 630,
    url: gubagooUrl,
    onError: () => setState({
      hasError: true,
      isUrlValid: state.isUrlValid
    })
  }, void 0, renderButton(className, onChatClick, rest, uiContext, isDealerNameRelocation));
}
export default /*#__PURE__*/React.memo(OwnerChatGubagoo);